import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'

export const DIALOG_OTP_UNVERIFIED = 'DIALOG_OTP_UNVERIFIED'

interface DialogOtpUnverifiedProps {
  onLogout: () => void
}

export const DialogOtpUnverified = ({ onLogout }: DialogOtpUnverifiedProps) => {
  const { open } = useDialog(DIALOG_OTP_UNVERIFIED)

  return (
    <Dialog open={open}>
      <DialogContent>
        <VStack mt={4} alignItems="center">
          <Text variant="h5">帳號未驗證</Text>
          <Text align="center">
            首次登入賣場需帳號驗證 (OTP) 才能購買商品！
          </Text>
        </VStack>
      </DialogContent>
      <DialogActions>
        <Button color="red" fullWidth onClick={onLogout}>
          回首頁，重新驗證帳號 OTP
        </Button>
      </DialogActions>
    </Dialog>
  )
}
